import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators as configActions } from "../../state/ducks/config";
import { actionCreators as authActions } from "../../state/ducks/auth";
import { HashRouter, Route, Redirect } from "react-router-dom";
import history from "../../utils/history";

import Login from "../Login";
import KbportLogin from "../KbportLogin";
import Room from "../Room";
import CreateRoom from "../CreateRoom";
import ListRooms from "../ListRooms";
// import AppStarter from "../AppStarter";
import Logo from "../Logo";

import "./AppStarter.css";

/**
 * This component makes sure that the janusApi is properly initialized.
 */
function AppStarter(props) {
  const dispatch = useDispatch();
  const config = useSelector((state) => state.config);
  const auth = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(configActions.load());
    dispatch(authActions.handleAuthentication());
    if (auth.state) {
      dispatch(authActions.getUserInfo());
    }
  }, [auth.kbportLogin, auth.state]);

  if (Object.entries(config).length === 0) {
    return (
      <div className="AppStarter">
        <div className="content">
          <Logo />
        </div>
      </div>
    );
  } else {
    // return <div className="theme-classic">{props.children}</div>;

    return (
      <div className="theme-classic">
        <HashRouter history={history}>
          {auth.state ? (
            <>
              <Route exact path="/" component={Login} />
              {auth.userData &&
                auth.userData.data &&
                auth.userData.data.UserRole === "Instructor" && (
                  <Route path="/create-room" component={CreateRoom} />
                )}
              {auth.userData &&
                auth.userData.data &&
                auth.userData.data.UserRole === "Instructor" && (
                  <Route path="/list-rooms" component={ListRooms} />
                )}
              <Route path="/room/:roomId" component={Login} />
              <Route path="/meeting-room" component={Room} />
              {/* <Route path="/room/:roomId/pin/:pin" component={Room} />
              <Route
                path="/room/:roomId/pin/:pin/:adminSecret"
                component={Room}
              /> */}
            </>
          ) : (
            <>
              <Route exact path="/" component={KbportLogin} />
              <Redirect from="/room/:roomId" to="/" />
            </>
          )}
        </HashRouter>
      </div>
    );
  }
}

export default AppStarter;
